/** Categories shown in the Tactic Alert filter. Add one when a new kind appears. */
export const TACTIC_KINDS: ReadonlyArray<{ id: string; label: string }> = [];

export type TacticKind = string;
export type TacticFilter = 'all' | TacticKind;

export function isTacticKind(value: string): boolean {
  return TACTIC_KINDS.some((k) => k.id === value);
}

export function tacticKindLabel(id: TacticKind): string {
  return TACTIC_KINDS.find((k) => k.id === id)?.label ?? 'Tactic';
}
